module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/interface/media-play-c4d6edd6bc4574cbba002d2ece6c3ad2.svg";